import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import {
	RequestOtpEmail,
	type RequestOtpEmailMutation,
	type RequestOtpEmailMutationVariables,
} from './requestOtpEmail.graphql';

export type RequestOtpEmailResponse = RequestOtpEmailMutation['requestOtpEmail'];

export async function requestOtpEmail(
	input: RequestOtpEmailMutationVariables['input'],
	{ gql: { fetch } }: UtilityContext,
): Promise<RequestOtpEmailResponse> {
	const { data, errors } = await fetch<RequestOtpEmailMutation, RequestOtpEmailMutationVariables>({
		path: '/login',
		query: RequestOtpEmail,
		variables: { input },
		rejectOnError: false,
		batched: false, // to ensure this rate limited mutation is not batched
	});

	if (errors) throw new Error(JSON.stringify(errors));
	if (!data) throw new Error('No data returned from query.');
	return data.requestOtpEmail;
}
